<app-page title="">
  <div body class="p-6 bg-white shadow-md rounded-lg">

    <!-- Avatar Section with Username and Change Password Button -->
    <div class="flex items-center mb-6 space-x-6">
      <!-- Avatar -->
      <p-avatar
        label="{{ getUserInitials() }}"
        styleClass="mr-3"
        size="large">
      </p-avatar>

      <!-- User Info Section -->
      <div>
        <h1 class="text-2xl font-bold text-gray-900">{{ user?.firstName || '' }} {{ user?.lastName || '' }}</h1>
        <!-- Username with Change Password Button -->
        <div class="flex items-center mt-2">
          <p class="text-gray-600 mr-3">{{ user?.username }}</p>
          <button pButton pRipple icon="pi pi-key" class="p-button-rounded p-button-secondary p-button-sm"
                  (click)="openChangePasswordPage(user?.username)" title="Change Password">
          </button>
        </div>
      </div>
    </div>

    <!-- User Information Section -->
    <div class="border-t border-gray-300 pt-4 mb-6">
      <h2 class="text-xl font-semibold text-gray-700 mb-4">User Information</h2>
      <div class="grid grid-cols-3 gap-4">
        <app-data-display label="Username" [value]="user?.username" />
        <app-data-display label="Middle Name" [value]="user?.middleName || '-' " />
        <app-data-display label="Last Name" [value]="user?.lastName" />
        <app-data-display label="Mobile Number" [value]="user?.mobileNumber || '-'" />
        <app-data-display label="Phone Number" [value]="user?.phoneNumber || '-'" />
        <app-data-display label="Email Id" [value]="user?.email" />
        <app-data-display label="Address" [value]="user?.address || '-'" />
        <app-data-display label="Last Logged In" [value]="user?.lastLogged | date:'medium'" />
        <app-data-display label="Last Password Changed" [value]="user?.lastPasswordChangedAt | date:'medium'" />
        <app-data-display label="Two Factor Enabled" [value]="user?.twoFactorEnabled ? 'Yes' : 'No'" />
<!--        <app-data-display label="Cross Branch" [value]="user?.crossBranch ? 'Enabled' : 'Disabled'" />-->
        <app-data-display label="Role" [value]="user?.role || '-'" />
        <app-data-display label="Account Non-Expired" [value]="user?.accountNonExpired ? 'Yes' : 'No'" />
        <app-data-display label="Account Non-Locked" [value]="user?.accountNonLocked ? 'Yes' : 'No'" />
        <app-data-display label="Credentials Non-Expired" [value]="user?.credentialNonExpired ? 'Yes' : 'No'" />
      </div>
    </div>

    <!-- Branch Information Section -->
    <div class="border-t border-gray-300 pt-4 mb-6">
      <h2 class="text-xl font-semibold text-gray-700 mb-4">Branch Information</h2>
      <div class="grid grid-cols-3 gap-4">
        <app-data-display label="Branch Name" [value]="user?.branch?.name" />
        <app-data-display label="Branch Code" [value]="user?.branch?.code" />
        <app-data-display label="Location" [value]="user?.branch?.location" />
        <app-data-display label="Phone Number" [value]="user?.branch?.phoneNumber || '-'" />
        <app-data-display label="Branch Status" [value]="user?.branch?.status || '-'" />
        <app-data-display label="Branch Access" [value]="user?.branchAccess" />
      </div>
    </div>

      @if (user?.branchAccess === 'CUSTOM') {
          <div class="border-t border-gray-300 pt-4 mb-6">
              <div class="flex items-center gap-8">
                  <div>
                      <h2 class="text-xl font-semibold text-gray-700">
                          Accessible Branches
                      </h2>

                      <p class="text-gray-500 mt-1">
                          {{ user?.branches?.length || 0 }} branch(es) accessible
                      </p>
                  </div>

                  <button
                          pButton
                          pRipple
                          label="View Branches"
                          icon="pi pi-eye"
                          class="p-button-outlined"
                          title="View Branches"
                          (click)="showBranches()"
                  >
                  </button>
              </div>
          </div>
      }
    <!-- Group Information Section -->
 <!--   <div class="border-t border-gray-300 pt-4 mb-6">
      <h2 class="text-xl font-semibold text-gray-700 mb-4">Role Information</h2>
      <div class="grid grid-cols-3 gap-4">
        &lt;!&ndash;<app-data-display label="Group Name" [value]="user.group.name || '-'" />&ndash;&gt;
        <app-data-display label="Group Description" [value]="user.group.description || '-'" />
        <app-data-display label="Group Status" [value]="user.group.status || '-'" />
        &lt;!&ndash; Roles displayed on separate lines &ndash;&gt;
        <app-data-display label="Roles" [value]="user.group.roles | displayRoles" />
      </div>
    </div>-->
  </div>
</app-page>
